(function () {
  'use strict';

  function initialize(root) {
    if (!root || root.dataset.bzAnnouncementInitialized === 'true') return;

    var track = root.querySelector('[data-bz-announcement-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-bz-announcement-slide]')) : [];
    var realCount = track ? parseInt(track.getAttribute('data-real-count'), 10) || slides.length : 0;
    var slideCount = slides.length;
    var previousButton = root.querySelector('.bz-announcement-bar__arrow--previous');
    var nextButtons = Array.prototype.slice.call(root.querySelectorAll('[data-bz-announcement-next]'));
    var pauseButton = root.querySelector('.bz-announcement-bar__pause');
    var mobileMessage = root.querySelector('[data-bz-announcement-current-message]');
    var autoplaySeconds = parseInt(root.getAttribute('data-autoplay-seconds'), 10) || 0;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var isPaused = false;

    function setTrackPosition(nextIndex, withoutTransition) {
      if (!track || !slideCount) return;
      track.style.transition = withoutTransition ? 'none' : '';
      track.style.transform = 'translateX(-' + (nextIndex * (100 / slideCount)) + '%)';
      if (withoutTransition) void track.offsetHeight;
    }

    function setActiveSlide(activeIndex) {
      var realIndex = activeIndex >= realCount ? 0 : activeIndex;

      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');
      });

      if (mobileMessage && slides[realIndex]) {
        mobileMessage.textContent = slides[realIndex].getAttribute('data-message') || '';
      }
    }

    function show(nextIndex, withoutTransition) {
      if (!track || realCount <= 1) {
        setActiveSlide(0);
        return;
      }

      index = nextIndex;
      setTrackPosition(index, withoutTransition);
      setActiveSlide(index);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (autoplaySeconds <= 0 || reducedMotion || isPaused || realCount <= 1) return;
      timer = window.setInterval(function () {
        showNext();
      }, autoplaySeconds * 1000);
    }

    function showPrevious(event) {
      if (event) event.preventDefault();
      stop();

      if (index >= realCount) {
        index = 0;
        setTrackPosition(0, true);
      }

      if (index === 0 && realCount > 1) {
        if (reducedMotion) {
          show(realCount - 1, true);
          start();
          return;
        }

        index = realCount;
        setTrackPosition(index, true);
        window.requestAnimationFrame(function () {
          show(realCount - 1, false);
        });
      } else {
        show(index - 1, false);
      }

      start();
    }

    function showNext(event) {
      if (event) event.preventDefault();
      stop();

      if (index >= realCount) {
        index = 0;
        setTrackPosition(0, true);
      }

      if (reducedMotion && index === realCount - 1) {
        show(0, true);
        start();
        return;
      }

      show(index + 1, false);
      start();
    }

    function updatePauseButton() {
      if (!pauseButton) return;
      pauseButton.setAttribute('aria-label', isPaused ? 'Resume autoplay' : 'Pause autoplay');
      pauseButton.textContent = isPaused ? 'Resume autoplay' : 'Pause autoplay';
    }

    function togglePause() {
      isPaused = !isPaused;
      updatePauseButton();
      if (isPaused) stop();
      else start();
    }

    if (track) {
      track.addEventListener('transitionend', function (event) {
        if (event.target !== track || event.propertyName !== 'transform') return;
        if (index !== realCount || slideCount <= realCount) return;

        index = 0;
        setTrackPosition(0, true);
        setActiveSlide(0);
        window.requestAnimationFrame(function () {
          track.style.transition = '';
        });
      });
    }

    if (previousButton) previousButton.addEventListener('click', showPrevious);
    nextButtons.forEach(function (button) {
      button.addEventListener('click', showNext);
    });
    if (pauseButton) pauseButton.addEventListener('click', togglePause);

    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }

    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    setTrackPosition(0, true);
    setActiveSlide(0);
    updatePauseButton();
    root.dataset.bzAnnouncementInitialized = 'true';
    start();
  }

  function initializeAll(container) {
    var scope = container && container.querySelectorAll ? container : document;
    scope.querySelectorAll('[data-bz-announcement-bar]').forEach(initialize);
    if (scope.matches && scope.matches('[data-bz-announcement-bar]')) initialize(scope);
  }

  if (window.BZAnnouncementBarInitializeAll) {
    window.BZAnnouncementBarInitializeAll(document);
    return;
  }

  window.BZAnnouncementBarInitializeAll = initializeAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
